import React from 'react';
import { useTranslation } from 'react-i18next';

import { formatAmountValue, sqlDateToLabel, fractionToPercent } from 'helpers/helpers';
import Grid from '@material-ui/core/Grid';
import H2 from 'apps/Pdf/components/common/H2';

import useGeneralStyles from 'apps/Pdf/styles/general';
import useStyles from '../Targets/TargetsStyle';
import { ReservesData } from 'stores/workflowStores/finances/newReservesStore/model';
import LockIcon from 'components/Icons/LockIcon';
import { Currency, EdwardColors } from 'enums';

interface Props {
  data: ReservesData;
  currency: Currency;
  original?: boolean;
}

const Reserves = (props: Props) => {
  const { t } = useTranslation();
  const styles = useGeneralStyles();
  const classes = useStyles();
  const { data, currency, original } = props;

  return data?.reserves && data.reserves.length > 0 ? (
    <>
      <div className={styles.avoidPageBreak}>
        <H2>Požadované rezervy</H2>
        {data.reserves.map((reserve) => {
          return (
            <Grid
              container
              item
              alignContent="center"
              alignItems="center"
              className={`${classes.target}`}
              key={reserve.id}
            >
              <Grid item xs={1} className={classes.icon}>
                <LockIcon fontSize="inherit" htmlColor={original ? EdwardColors.GRAY_MEDIUM : undefined} />
              </Grid>
              <Grid item xs={11}>
                <span className={styles.mediumText}>{reserve.title}</span>
                <br />
                <strong>{formatAmountValue(reserve.value.value, currency)}</strong>
                {' | '}
                {t('general_portfolio')}
                {': '}
                <strong>{t(`finQuestionnary_reserve_bucket_${reserve.bucket}`)}</strong>
                {' | '}
                {!reserve?.until && t(`options_horizon_${reserve.horizon}`)}
                {reserve?.until && (
                  <>
                    {` ${t('general_until')}: `}
                    {` ${sqlDateToLabel(reserve.until)}`}
                  </>
                )}
                {reserve.cancellationLimitActive &&
                  ` | ${t('reserve_cancel')} ${fractionToPercent(reserve.cancellationLimit as number, 0, true)}% ${t(
                    'reserve_cancelFall',
                  )} `}
                {reserve.newDeposits && ` | ${t('reserve_newDeposits').toLowerCase()}`}
              </Grid>
            </Grid>
          );
        })}
      </div>
    </>
  ) : null;
};

export default Reserves;
